export default __webpack_public_path__ + "static/media/info.d960436e.svg";